export default __webpack_public_path__ + "alberta-fab-subunit.000a0cb3c93804c79e0a.svg";